exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".row-icon[data-v-473e6149]{fill:var(--table-icon)}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/NewProblemsCell.vue"],"names":[],"mappings":"AAwCA,2BACI,sBAAwB,CAC3B","file":"NewProblemsCell.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Kolor z tokenu --table-icon (assets/css/theme.css), jak w TableButtons.vue. */\n.row-icon[data-v-473e6149] {\n    fill: var(--table-icon);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-473e6149","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Systems/NewProblemsCell.vue
// module id = 2117
// module chunks = 3